import { green } from "@mui/material/colors";
import { ModuleRegistry } from "ag-grid-community";
import {
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  MultiFilterModule,
  SetFilterModule,
  SideBarModule,
} from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import { forwardRef, useCallback, useMemo } from "react";
import { agApiSizeColumnsToFit } from "../../../../../_src_shared/utils/agGrid/api/agApiSizeColumnsToFit";
import { columnTypesDollar } from "../../../../../_src_shared/utils/agGrid/columnTypes/columnTypesDollar";
import AgGridTableWrapper from "../../../../../components/agGrid/AgGridTableWrapper";
import { isEmpty } from "lodash";

ModuleRegistry.registerModules([
  SideBarModule,
  MultiFilterModule,
  FiltersToolPanelModule,
  ColumnsToolPanelModule,
  SetFilterModule,
]);

const OriginatorCreditsTable = forwardRef(
  (
    {
      rowData,
      loanAmount = 0,
      onRowClicked,
      loading,
      quickFilterText,
      showTotals = true,
    },
    ref
  ) => {
    const columnDefs = useMemo(() => {
      return [
        {
          headerName: "CREDIT NAME",
          field: "itemName",
          minWidth: 200,
          flex: 1.5,
          cellClass: "ag-cell-vertical-center",
          cellStyle: { paddingTop: "8px", paddingBottom: "8px" },
        },
        {
          headerName: "AMOUNT",
          field: "itemAmount",
          minWidth: 120,
          flex: 1,
          type: "dollar",
          cellClass: "ag-cell-vertical-center ag-right-aligned-cell",
          valueFormatter: (params) => {
            if (params.value == null) return "";
            const value = parseFloat(params.value);
            if (isNaN(value)) return "";
            return `$${value.toFixed(2)}`;
          },
          cellStyle: { color: green[900] },
        },
        {
          headerName: "PERCENT",
          field: "itemPercent",
          minWidth: 100,
          flex: 0.8,
          cellClass: "ag-cell-vertical-center ag-right-aligned-cell",
          valueFormatter: (params) => {
            if (params.value == null) return "";
            const value = parseFloat(params.value);
            if (isNaN(value)) return "";
            return `${(value * 100).toFixed(3)}%`;
          },
          //   cellStyle: { color: grey[600] },
        },
        {
          headerName: "CALCULATED VALUE",
          field: "calculatedValue",
          minWidth: 140,
          flex: 1,
          cellClass: "ag-cell-vertical-center ag-right-aligned-cell",
          valueGetter: (params) => {
            const { itemAmount, itemPercent } = params.data;

            if (itemAmount !== null && itemAmount !== undefined) {
              return itemAmount;
            }

            if (
              itemPercent !== null &&
              itemPercent !== undefined &&
              loanAmount > 0
            ) {
              return loanAmount * itemPercent;
            }

            return 0;
          },
          valueFormatter: (params) => {
            const value = parseFloat(params.value);
            if (isNaN(value)) return "-$0.00";
            // Credits are shown as negative values
            return `-$${Math.abs(value).toFixed(2)}`;
          },
          cellStyle: {
            fontWeight: 600,
            color: green[900],
          },
        },
        {
          headerName: "NOTE",
          field: "itemNote",
          minWidth: 200,
          flex: 2,
          cellClass: "ag-cell-vertical-center",
          wrapText: true,
          autoHeight: true,
          resizable: true,
          cellStyle: {
            // color: grey[700],

            //
            lineHeight: "1.4",
          },
        },
        // {
        //   headerName: "ACTIONS",
        //   field: "actions",
        //   minWidth: 80,
        //   maxWidth: 80,
        //   sortable: false,
        //   filter: false,
        //   cellClass: "ag-cell-vertical-center ag-center-aligned-cell",
        //   cellRenderer: (params) => {
        //     if (params.node.rowPinned) return null;

        //     return (
        //       <IconButton
        //         size="small"
        //         onClick={(e) => {
        //           e.stopPropagation();
        //           onDeleteCredit?.(params.data);
        //         }}
        //         sx={{ color: grey[500], "&:hover": { color: "error.main" } }}
        //       >
        //         <CloseRounded fontSize="small" />
        //       </IconButton>
        //     );
        //   },
        // },
      ];
    }, [loanAmount]);
    // const columnDefs = useMemo(() => {
    //   return [
    //     {
    //       headerName: "FEE NAME",
    //       field: "itemName",
    //       //   minWidth: 200,
    //       minWidth: 100,
    //       //   flex: 1.5,
    //       cellStyle: { paddingTop: "8px", paddingBottom: "8px" },
    //     },
    //     {
    //       headerName: "AMOUNT",
    //       field: "itemAmount",
    //       minWidth: 100,
    //       width: 140,
    //       maxWidth: 140,
    //       //   minWidth: 120,
    //       //   flex: 1,
    //       type: "dollar",
    //       valueFormatter: (params) => {
    //         if (params.value == null) return "";
    //         const value = parseFloat(params.value);
    //         if (isNaN(value)) return "";
    //         return `$${value.toFixed(2)}`;
    //       },
    //     },
    //     {
    //       headerName: "PERCENT",
    //       field: "itemPercent",
    //       minWidth: 100,
    //       //   flex: 0.8,
    //       width: 120,
    //       maxWidth: 120,
    //       valueFormatter: (params) => {
    //         if (params.value == null) return "";
    //         const value = parseFloat(params.value);
    //         if (isNaN(value)) return "";
    //         return `${(value * 100).toFixed(3)}%`;
    //       },
    //       cellStyle: { color: grey[600] },
    //     },
    //     {
    //       headerName: "CALCULATED VALUE",
    //       field: "calculatedValue",
    //       minWidth: 140,
    //       width: 160,
    //       maxWidth: 160,
    //       valueGetter: (params) => {
    //         const { node, data } = params || {};
    //         const { itemAmount, itemPercent, calculatedValue } = data || {};

    //         // For pinned total row: just use precomputed total
    //         if (node.rowPinned) {
    //           return calculatedValue ?? 0;
    //         }

    //         if (itemAmount !== null && itemAmount !== undefined) {
    //           return parseFloat(itemAmount) || 0;
    //         }

    //         if (
    //           itemPercent !== null &&
    //           itemPercent !== undefined &&
    //           loanAmount > 0
    //         ) {
    //           return loanAmount * itemPercent;
    //         }

    //         return 0;
    //       },
    //       valueFormatter: (params) => {
    //         const value = parseFloat(params.value);
    //         if (isNaN(value)) return "$0.00";
    //         return `$${value.toFixed(2)}`;
    //       },
    //       cellStyle: { fontWeight: 600 },
    //     },
    //     {
    //       headerName: "PAYMENT",
    //       field: "payment",
    //       minWidth: 120,
    //       width: 120,
    //       maxWidth: 120,

    //       valueFormatter: (params) => {
    //         const { paidAtClosing, paidOutsideClosing } = params.data;

    //         if (paidAtClosing) {
    //           return "At Closing";
    //         }
    //         if (paidOutsideClosing) {
    //           return "Outside";
    //         }
    //       },
    //     },
    //     {
    //       headerName: "NOTE",
    //       field: "itemNote",
    //       minWidth: 250,
    //       tooltipValueGetter: (params) => params.value,

    //       flex: 1,

    //       wrapText: true,
    //       autoHeight: true,
    //       resizable: true,
    //       cellStyle: {
    //         lineHeight: "1.4",
    //       },
    //     },
    //   ];
    // }, [loanAmount]);

    const handleOnRowClicked = useCallback(
      (params) => {
        if (params.node.rowPinned) return;
        onRowClicked?.(params?.data);
      },
      [onRowClicked]
    );

    const defaultColDef = useMemo(
      () => ({
        filter: true,
        flex: 1,
        cellClass: "ag-cell-vertical-center",
        suppressHeaderFilterButton: true,
        suppressHeaderMenuButton: true,
        resizable: true,
        sortable: true,
      }),
      []
    );

    const columnTypes = useMemo(
      () => ({
        ...columnTypesDollar(),
      }),
      []
    );

    const onFirstDataRendered = useCallback((params) => {
      agApiSizeColumnsToFit(params);
    }, []);

    // Calculate total fees
    const totalCredits = useMemo(() => {
      if (!rowData || !Array.isArray(rowData)) return 0;
      return rowData.reduce((sum, credit) => {
        if (credit.itemAmount !== null && credit.itemAmount !== undefined) {
          return sum + parseFloat(credit.itemAmount);
        }
        if (
          credit.itemPercent !== null &&
          credit.itemPercent !== undefined &&
          loanAmount > 0
        ) {
          return sum + loanAmount * credit.itemPercent;
        }
        return sum;
      }, 0);
    }, [rowData, loanAmount]);

    // Pinned bottom row for totals
    const pinnedBottomRowData = useMemo(() => {
      if (!showTotals || isEmpty(rowData)) return undefined;
      return [
        {
          itemName: "TOTAL CREDITS",
          calculatedValue: totalCredits,
          itemNote: `${rowData?.length || 0} credits applied`,
          isPinnedRow: true,
        },
      ];
    }, [showTotals, totalCredits, rowData]);

    const getRowStyle = useCallback((params) => {
      if (params.node.rowPinned) {
        return {
          fontWeight: "bold",
          backgroundColor: green[50],
        };
      }
      return null;
    }, []);

    return (
      <AgGridTableWrapper
        suppressMinHeightWhenPopulated={rowData}
        simpleTable
        sx={{ minWidth: "800px" }}
      >
        <AgGridReact
          ref={ref}
          rowData={rowData}
          loading={loading}
          columnDefs={columnDefs}
          //   columnDefs={dynamicColumnDefs}
          defaultColDef={defaultColDef}
          quickFilterText={quickFilterText}
          tooltipShowDelay={100}
          onFirstDataRendered={onFirstDataRendered}
          columnTypes={columnTypes}
          domLayout={"autoHeight"}
          rowHeight={50}
          onRowClicked={handleOnRowClicked}
          pinnedBottomRowData={pinnedBottomRowData}
          getRowStyle={getRowStyle}
        />
      </AgGridTableWrapper>
    );
  }
);

OriginatorCreditsTable.displayName = "OriginatorCreditsTable";

export default OriginatorCreditsTable;
